import { render, staticRenderFns } from "./ListCRMs.vue?vue&type=template&id=68407df4"
import script from "./ListCRMs.vue?vue&type=script&lang=js"
export * from "./ListCRMs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports